export var VELT_SDK_VERSION = '4.5.0-beta.64';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.0-beta.64': 'sha384-A2mLpoSvdDIRMS1KNJssa1+W2227CkbrlKSr0p/rM/3BJ7iEdKY9CB7udKX96NqC',
};
